// This is a generated file. DO NOT modify directly.

export const IconNameMapper = {
  add: 'AddIcon',
  'add-column-left': 'AddColumnLeftIcon',
  'add-column-right': 'AddColumnRightIcon',
  'add-row-bottom': 'AddRowBottomIcon',
  'add-row-top': 'AddRowTopIcon',
  'add-to-artifact': 'AddToArtifactIcon',
  'add-to-folder': 'AddToFolderIcon',
  airplane: 'AirplaneIcon',
  'align-center': 'AlignCenterIcon',
  'align-justify': 'AlignJustifyIcon',
  'align-left': 'AlignLeftIcon',
  'align-right': 'AlignRightIcon',
  'alignment-bottom': 'AlignmentBottomIcon',
  'alignment-horizontal-center': 'AlignmentHorizontalCenterIcon',
  'alignment-left': 'AlignmentLeftIcon',
  'alignment-right': 'AlignmentRightIcon',
  'alignment-top': 'AlignmentTopIcon',
  'alignment-vertical-center': 'AlignmentVerticalCenterIcon',
  annotation: 'AnnotationIcon',
  application: 'ApplicationIcon',
  applications: 'ApplicationsIcon',
  archive: 'ArchiveIcon',
  'arrow-bottom-left': 'ArrowBottomLeftIcon',
  'arrow-bottom-right': 'ArrowBottomRightIcon',
  'arrow-down': 'ArrowDownIcon',
  'arrow-left': 'ArrowLeftIcon',
  'arrow-right': 'ArrowRightIcon',
  'arrow-top-left': 'ArrowTopLeftIcon',
  'arrow-top-right': 'ArrowTopRightIcon',
  'arrow-up': 'ArrowUpIcon',
  'arrows-horizontal': 'ArrowsHorizontalIcon',
  'arrows-vertical': 'ArrowsVerticalIcon',
  asterisk: 'AsteriskIcon',
  'automatic-updates': 'AutomaticUpdatesIcon',
  badge: 'BadgeIcon',
  'ban-circle': 'BanCircleIcon',
  'bank-account': 'BankAccountIcon',
  barcode: 'BarcodeIcon',
  blank: 'BlankIcon',
  'blocked-person': 'BlockedPersonIcon',
  bold: 'BoldIcon',
  book: 'BookIcon',
  bookmark: 'BookmarkIcon',
  box: 'BoxIcon',
  briefcase: 'BriefcaseIcon',
  'bring-data': 'BringDataIcon',
  build: 'BuildIcon',
  calculator: 'CalculatorIcon',
  calendar: 'CalendarIcon',
  camera: 'CameraIcon',
  'caret-down': 'CaretDownIcon',
  'caret-left': 'CaretLeftIcon',
  'caret-right': 'CaretRightIcon',
  'caret-up': 'CaretUpIcon',
  'cell-tower': 'CellTowerIcon',
  changes: 'ChangesIcon',
  chart: 'ChartIcon',
  chat: 'ChatIcon',
  'chevron-backward': 'ChevronBackwardIcon',
  'chevron-down': 'ChevronDownIcon',
  'chevron-forward': 'ChevronForwardIcon',
  'chevron-left': 'ChevronLeftIcon',
  'chevron-right': 'ChevronRightIcon',
  'chevron-up': 'ChevronUpIcon',
  circle: 'CircleIcon',
  'circle-arrow-down': 'CircleArrowDownIcon',
  'circle-arrow-left': 'CircleArrowLeftIcon',
  'circle-arrow-right': 'CircleArrowRightIcon',
  'circle-arrow-up': 'CircleArrowUpIcon',
  citation: 'CitationIcon',
  clean: 'CleanIcon',
  clipboard: 'ClipboardIcon',
  cloud: 'CloudIcon',
  'cloud-download': 'CloudDownloadIcon',
  'cloud-upload': 'CloudUploadIcon',
  code: 'CodeIcon',
  'code-block': 'CodeBlockIcon',
  cog: 'CogIcon',
  'collapse-all': 'CollapseAllIcon',
  'column-layout': 'ColumnLayoutIcon',
  comment: 'CommentIcon',
  comparison: 'ComparisonIcon',
  compass: 'CompassIcon',
  compressed: 'CompressedIcon',
  confirm: 'ConfirmIcon',
  console: 'ConsoleIcon',
  contrast: 'ContrastIcon',
  control: 'ControlIcon',
  'credit-card': 'CreditCardIcon',
  cross: 'CrossIcon',
  crown: 'CrownIcon',
  cube: 'CubeIcon',
  'cube-add': 'CubeAddIcon',
  'cube-remove': 'CubeRemoveIcon',
  'curved-range-chart': 'CurvedRangeChartIcon',
  cut: 'CutIcon',
  dashboard: 'DashboardIcon',
  'data-lineage': 'DataLineageIcon',
  database: 'DatabaseIcon',
  delete: 'DeleteIcon',
  delta: 'DeltaIcon',
  'derive-column': 'DeriveColumnIcon',
  desktop: 'DesktopIcon',
  'diagram-tree': 'DiagramTreeIcon',
  'direction-left': 'DirectionLeftIcon',
  'direction-right': 'DirectionRightIcon',
  disable: 'DisableIcon',
  document: 'DocumentIcon',
  'document-open': 'DocumentOpenIcon',
  'document-share': 'DocumentShareIcon',
  dollar: 'DollarIcon',
  dot: 'DotIcon',
  'double-caret-horizontal': 'DoubleCaretHorizontalIcon',
  'double-caret-vertical': 'DoubleCaretVerticalIcon',
  'double-chevron-down': 'DoubleChevronDownIcon',
  'double-chevron-left': 'DoubleChevronLeftIcon',
  'double-chevron-right': 'DoubleChevronRightIcon',
  'double-chevron-up': 'DoubleChevronUpIcon',
  'doughnut-chart': 'DoughnutChartIcon',
  download: 'DownloadIcon',
  'drag-handle-horizontal': 'DragHandleHorizontalIcon',
  'drag-handle-vertical': 'DragHandleVerticalIcon',
  draw: 'DrawIcon',
  'drive-time': 'DriveTimeIcon',
  duplicate: 'DuplicateIcon',
  edit: 'EditIcon',
  eject: 'EjectIcon',
  endorsed: 'EndorsedIcon',
  envelope: 'EnvelopeIcon',
  equals: 'EqualsIcon',
  eraser: 'EraserIcon',
  error: 'ErrorIcon',
  euro: 'EuroIcon',
  exchange: 'ExchangeIcon',
  'exclude-row': 'ExcludeRowIcon',
  'expand-all': 'ExpandAllIcon',
  export: 'ExportIcon',
  'eye-off': 'EyeOffIcon',
  'eye-on': 'EyeOnIcon',
  'eye-open': 'EyeOpenIcon',
  'fast-backward': 'FastBackwardIcon',
  'fast-forward': 'FastForwardIcon',
  feed: 'FeedIcon',
  'feed-subscribed': 'FeedSubscribedIcon',
  film: 'FilmIcon',
  filter: 'FilterIcon',
  'filter-keep': 'FilterKeepIcon',
  'filter-list': 'FilterListIcon',
  'filter-open': 'FilterOpenIcon',
  'filter-remove': 'FilterRemoveIcon',
  flag: 'FlagIcon',
  flame: 'FlameIcon',
  flash: 'FlashIcon',
  'floppy-disk': 'FloppyDiskIcon',
  'flow-branch': 'FlowBranchIcon',
  'flow-end': 'FlowEndIcon',
  'flow-linear': 'FlowLinearIcon',
  'flow-review': 'FlowReviewIcon',
  'flow-review-branch': 'FlowReviewBranchIcon',
  flows: 'FlowsIcon',
  'folder-close': 'FolderCloseIcon',
  'folder-new': 'FolderNewIcon',
  'folder-open': 'FolderOpenIcon',
  'folder-shared': 'FolderSharedIcon',
  'folder-shared-open': 'FolderSharedOpenIcon',
  follower: 'FollowerIcon',
  following: 'FollowingIcon',
  font: 'FontIcon',
  fork: 'ForkIcon',
  form: 'FormIcon',
  'full-circle': 'FullCircleIcon',
  'full-stacked-chart': 'FullStackedChartIcon',
  fullscreen: 'FullscreenIcon',
  function: 'FunctionIcon',
  'gantt-chart': 'GanttChartIcon',
  geolocation: 'GeolocationIcon',
  geosearch: 'GeosearchIcon',
  'git-branch': 'GitBranchIcon',
  'git-commit': 'GitCommitIcon',
  'git-merge': 'GitMergeIcon',
  'git-new-branch': 'GitNewBranchIcon',
  'git-pull': 'GitPullIcon',
  'git-push': 'GitPushIcon',
  'git-repo': 'GitRepoIcon',
  glass: 'GlassIcon',
  globe: 'GlobeIcon',
  'globe-network': 'GlobeNetworkIcon',
  graph: 'GraphIcon',
  'graph-remove': 'GraphRemoveIcon',
  'greater-than': 'GreaterThanIcon',
  'greater-than-or-equal-to': 'GreaterThanOrEqualToIcon',
  grid: 'GridIcon',
  'grid-view': 'GridViewIcon',
  'group-objects': 'GroupObjectsIcon',
  'grouped-bar-chart': 'GroupedBarChartIcon',
  hand: 'HandIcon',
  'hand-down': 'HandDownIcon',
  'hand-left': 'HandLeftIcon',
  'hand-right': 'HandRightIcon',
  'hand-up': 'HandUpIcon',
  header: 'HeaderIcon',
  'header-one': 'HeaderOneIcon',
  'header-two': 'HeaderTwoIcon',
  headset: 'HeadsetIcon',
  heart: 'HeartIcon',
  'heart-broken': 'HeartBrokenIcon',
  'heat-grid': 'HeatGridIcon',
  heatmap: 'HeatmapIcon',
  help: 'HelpIcon',
  'helper-management': 'HelperManagementIcon',
  highlight: 'HighlightIcon',
  history: 'HistoryIcon',
  home: 'HomeIcon',
  'horizontal-bar-chart': 'HorizontalBarChartIcon',
  'horizontal-bar-chart-asc': 'HorizontalBarChartAscIcon',
  'horizontal-bar-chart-desc': 'HorizontalBarChartDescIcon',
  'horizontal-distribution': 'HorizontalDistributionIcon',
  'id-number': 'IdNumberIcon',
  'image-rotate-left': 'ImageRotateLeftIcon',
  'image-rotate-right': 'ImageRotateRightIcon',
  import: 'ImportIcon',
  inbox: 'InboxIcon',
  'inbox-filtered': 'InboxFilteredIcon',
  'inbox-geo': 'InboxGeoIcon',
  'inbox-search': 'InboxSearchIcon',
  'inbox-update': 'InboxUpdateIcon',
  'info-sign': 'InfoSignIcon',
  inheritance: 'InheritanceIcon',
  'inner-join': 'InnerJoinIcon',
  insert: 'InsertIcon',
  intersection: 'IntersectionIcon',
  'ip-address': 'IpAddressIcon',
  issue: 'IssueIcon',
  'issue-closed': 'IssueClosedIcon',
  'issue-new': 'IssueNewIcon',
  italic: 'ItalicIcon',
  'join-table': 'JoinTableIcon',
  key: 'KeyIcon',
  'key-backspace': 'KeyBackspaceIcon',
  'key-command': 'KeyCommandIcon',
  'key-control': 'KeyControlIcon',
  'key-delete': 'KeyDeleteIcon',
  'key-enter': 'KeyEnterIcon',
  'key-escape': 'KeyEscapeIcon',
  'key-option': 'KeyOptionIcon',
  'key-shift': 'KeyShiftIcon',
  'key-tab': 'KeyTabIcon',
  'known-vehicle': 'KnownVehicleIcon',
  label: 'LabelIcon',
  layer: 'LayerIcon',
  layers: 'LayersIcon',
  layout: 'LayoutIcon',
  'layout-auto': 'LayoutAutoIcon',
  'layout-balloon': 'LayoutBalloonIcon',
  'layout-circle': 'LayoutCircleIcon',
  'layout-grid': 'LayoutGridIcon',
  'layout-group-by': 'LayoutGroupByIcon',
  'layout-hierarchy': 'LayoutHierarchyIcon',
  'layout-linear': 'LayoutLinearIcon',
  'layout-skew-grid': 'LayoutSkewGridIcon',
  'layout-sorted-clusters': 'LayoutSortedClustersIcon',
  learning: 'LearningIcon',
  'left-join': 'LeftJoinIcon',
  'less-than': 'LessThanIcon',
  'less-than-or-equal-to': 'LessThanOrEqualToIcon',
  lifesaver: 'LifesaverIcon',
  lightbulb: 'LightbulbIcon',
  link: 'LinkIcon',
  list: 'ListIcon',
  'list-columns': 'ListColumnsIcon',
  'list-detail-view': 'ListDetailViewIcon',
  locate: 'LocateIcon',
  lock: 'LockIcon',
  'log-in': 'LogInIcon',
  'log-out': 'LogOutIcon',
  manual: 'ManualIcon',
  'manually-entered-data': 'ManuallyEnteredDataIcon',
  map: 'MapIcon',
  'map-create': 'MapCreateIcon',
  'map-marker': 'MapMarkerIcon',
  maximize: 'MaximizeIcon',
  media: 'MediaIcon',
  menu: 'MenuIcon',
  'menu-closed': 'MenuClosedIcon',
  'menu-open': 'MenuOpenIcon',
  'merge-columns': 'MergeColumnsIcon',
  'merge-links': 'MergeLinksIcon',
  minimize: 'MinimizeIcon',
  minus: 'MinusIcon',
  'mobile-phone': 'MobilePhoneIcon',
  'mobile-video': 'MobileVideoIcon',
  moon: 'MoonIcon',
  more: 'MoreIcon',
  mountain: 'MountainIcon',
  move: 'MoveIcon',
  mugshot: 'MugshotIcon',
  'multi-select': 'MultiSelectIcon',
  music: 'MusicIcon',
  'new-drawing': 'NewDrawingIcon',
  'new-grid-item': 'NewGridItemIcon',
  'new-layer': 'NewLayerIcon',
  'new-layers': 'NewLayersIcon',
  'new-link': 'NewLinkIcon',
  'new-object': 'NewObjectIcon',
  'new-person': 'NewPersonIcon',
  'new-prescription': 'NewPrescriptionIcon',
  'new-text-box': 'NewTextBoxIcon',
  ninja: 'NinjaIcon',
  'not-equal-to': 'NotEqualToIcon',
  notifications: 'NotificationsIcon',
  'notifications-updated': 'NotificationsUpdatedIcon',
  'numbered-list': 'NumberedListIcon',
  numerical: 'NumericalIcon',
  office: 'OfficeIcon',
  offline: 'OfflineIcon',
  'oil-field': 'OilFieldIcon',
  'one-column': 'OneColumnIcon',
  outdated: 'OutdatedIcon',
  'page-layout': 'PageLayoutIcon',
  'panel-stats': 'PanelStatsIcon',
  'panel-table': 'PanelTableIcon',
  paperclip: 'PaperclipIcon',
  paragraph: 'ParagraphIcon',
  path: 'PathIcon',
  'path-search': 'PathSearchIcon',
  pause: 'PauseIcon',
  people: 'PeopleIcon',
  percentage: 'PercentageIcon',
  person: 'PersonIcon',
  phone: 'PhoneIcon',
  'pie-chart': 'PieChartIcon',
  pin: 'PinIcon',
  pivot: 'PivotIcon',
  'pivot-table': 'PivotTableIcon',
  play: 'PlayIcon',
  plus: 'PlusIcon',
  'polygon-filter': 'PolygonFilterIcon',
  power: 'PowerIcon',
  'predictive-analysis': 'PredictiveAnalysisIcon',
  prescription: 'PrescriptionIcon',
  presentation: 'PresentationIcon',
  print: 'PrintIcon',
  projects: 'ProjectsIcon',
  properties: 'PropertiesIcon',
  property: 'PropertyIcon',
  'publish-function': 'PublishFunctionIcon',
  pulse: 'PulseIcon',
  random: 'RandomIcon',
  record: 'RecordIcon',
  redo: 'RedoIcon',
  refresh: 'RefreshIcon',
  'regression-chart': 'RegressionChartIcon',
  remove: 'RemoveIcon',
  'remove-column': 'RemoveColumnIcon',
  'remove-column-left': 'RemoveColumnLeftIcon',
  'remove-column-right': 'RemoveColumnRightIcon',
  'remove-row-bottom': 'RemoveRowBottomIcon',
  'remove-row-top': 'RemoveRowTopIcon',
  repeat: 'RepeatIcon',
  reset: 'ResetIcon',
  resolve: 'ResolveIcon',
  rig: 'RigIcon',
  'right-join': 'RightJoinIcon',
  ring: 'RingIcon',
  'rotate-document': 'RotateDocumentIcon',
  'rotate-page': 'RotatePageIcon',
  satellite: 'SatelliteIcon',
  saved: 'SavedIcon',
  'scatter-plot': 'ScatterPlotIcon',
  search: 'SearchIcon',
  'search-around': 'SearchAroundIcon',
  'search-template': 'SearchTemplateIcon',
  'search-text': 'SearchTextIcon',
  'segmented-control': 'SegmentedControlIcon',
  select: 'SelectIcon',
  selection: 'SelectionIcon',
  'send-to': 'SendToIcon',
  'send-to-graph': 'SendToGraphIcon',
  'send-to-map': 'SendToMapIcon',
  'series-add': 'SeriesAddIcon',
  'series-configuration': 'SeriesConfigurationIcon',
  'series-derived': 'SeriesDerivedIcon',
  'series-filtered': 'SeriesFilteredIcon',
  'series-search': 'SeriesSearchIcon',
  settings: 'SettingsIcon',
  share: 'ShareIcon',
  shield: 'ShieldIcon',
  shop: 'ShopIcon',
  'shopping-cart': 'ShoppingCartIcon',
  'signal-search': 'SignalSearchIcon',
  'sim-card': 'SimCardIcon',
  slash: 'SlashIcon',
  'small-cross': 'SmallCrossIcon',
  'small-minus': 'SmallMinusIcon',
  'small-plus': 'SmallPlusIcon',
  'small-tick': 'SmallTickIcon',
  snowflake: 'SnowflakeIcon',
  'social-media': 'SocialMediaIcon',
  sort: 'SortIcon',
  'sort-alphabetical': 'SortAlphabeticalIcon',
  'sort-alphabetical-desc': 'SortAlphabeticalDescIcon',
  'sort-asc': 'SortAscIcon',
  'sort-desc': 'SortDescIcon',
  'sort-numerical': 'SortNumericalIcon',
  'sort-numerical-desc': 'SortNumericalDescIcon',
  'split-columns': 'SplitColumnsIcon',
  square: 'SquareIcon',
  'stacked-chart': 'StackedChartIcon',
  star: 'StarIcon',
  'star-empty': 'StarEmptyIcon',
  'step-backward': 'StepBackwardIcon',
  'step-chart': 'StepChartIcon',
  'step-forward': 'StepForwardIcon',
  stop: 'StopIcon',
  stopwatch: 'StopwatchIcon',
  strikethrough: 'StrikethroughIcon',
  style: 'StyleIcon',
  'swap-horizontal': 'SwapHorizontalIcon',
  'swap-vertical': 'SwapVerticalIcon',
  'symbol-circle': 'SymbolCircleIcon',
  'symbol-cross': 'SymbolCrossIcon',
  'symbol-diamond': 'SymbolDiamondIcon',
  'symbol-square': 'SymbolSquareIcon',
  'symbol-triangle-down': 'SymbolTriangleDownIcon',
  'symbol-triangle-up': 'SymbolTriangleUpIcon',
  tag: 'TagIcon',
  'take-action': 'TakeActionIcon',
  taxi: 'TaxiIcon',
  'text-highlight': 'TextHighlightIcon',
  th: 'ThIcon',
  'th-derived': 'ThDerivedIcon',
  'th-disconnect': 'ThDisconnectIcon',
  'th-filtered': 'ThFilteredIcon',
  'th-list': 'ThListIcon',
  'thumbs-down': 'ThumbsDownIcon',
  'thumbs-up': 'ThumbsUpIcon',
  tick: 'TickIcon',
  'tick-circle': 'TickCircleIcon',
  time: 'TimeIcon',
  'timeline-area-chart': 'TimelineAreaChartIcon',
  'timeline-bar-chart': 'TimelineBarChartIcon',
  'timeline-events': 'TimelineEventsIcon',
  'timeline-line-chart': 'TimelineLineChartIcon',
  tint: 'TintIcon',
  torch: 'TorchIcon',
  tractor: 'TractorIcon',
  train: 'TrainIcon',
  translate: 'TranslateIcon',
  trash: 'TrashIcon',
  tree: 'TreeIcon',
  'trending-down': 'TrendingDownIcon',
  'trending-up': 'TrendingUpIcon',
  truck: 'TruckIcon',
  'two-columns': 'TwoColumnsIcon',
  unarchive: 'UnarchiveIcon',
  underline: 'UnderlineIcon',
  undo: 'UndoIcon',
  'ungroup-objects': 'UngroupObjectsIcon',
  'unknown-vehicle': 'UnknownVehicleIcon',
  unlock: 'UnlockIcon',
  unpin: 'UnpinIcon',
  unresolve: 'UnresolveIcon',
  updated: 'UpdatedIcon',
  upload: 'UploadIcon',
  user: 'UserIcon',
  variable: 'VariableIcon',
  'vertical-bar-chart-asc': 'VerticalBarChartAscIcon',
  'vertical-bar-chart-desc': 'VerticalBarChartDescIcon',
  'vertical-distribution': 'VerticalDistributionIcon',
  video: 'VideoIcon',
  'volume-down': 'VolumeDownIcon',
  'volume-off': 'VolumeOffIcon',
  'volume-up': 'VolumeUpIcon',
  walk: 'WalkIcon',
  'warning-sign': 'WarningSignIcon',
  'waterfall-chart': 'WaterfallChartIcon',
  widget: 'WidgetIcon',
  'widget-button': 'WidgetButtonIcon',
  'widget-footer': 'WidgetFooterIcon',
  'widget-header': 'WidgetHeaderIcon',
  wrench: 'WrenchIcon',
  'zoom-in': 'ZoomInIcon',
  'zoom-out': 'ZoomOutIcon',
  'zoom-to-fit': 'ZoomToFitIcon'
}
